import React from 'react';

type Props = {
  id: string;
  name?: string;
  label?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
  hasError?: boolean;
  noCheckbox?: boolean;
  disabled?: boolean;
  required?: boolean;
};

export const Checkbox = ({ id, label, onChange, checked, hasError, noCheckbox, disabled, required }: Props) => {
  return (
    <div className={`field ${hasError ? 'has-error' : ''}`}>
      <label
        className='flex items-center gap-x-4'
        htmlFor={id}
      >
        <input
          type='checkbox'
          id={id}
          checked={checked}
          onChange={onChange}
          className={noCheckbox ? '!hidden' : ''}
          disabled={disabled}
          required={required}
        />
        {label && <span>{label}</span>}
      </label>
    </div>
  );
};
